// TODO: Retirer lodash qui ne sert qu'une seule fois
import _ from 'lodash';
import Cookies from 'js-cookie';
import moment from 'moment';
import i18n from '@/js/i18n';

import store from '@/store';
import router from '@/router';
import session from '@/services/api/compte/session';

import { browser, browserVersion } from '@/helpers/UserAgentHelpers2';

import {
  inEditor,
  getUrlContext,
  hasCodePromo,
  inAppMobile,
  inIOSApp,
  inMojPlusApp,
  nettoyerLienExterne,
  inMgnl,
} from '@/helpers/AppHelpers';
import { PageMapping, PageMappingCasino } from '@/helpers/PageMappingHelpers';
import {
  playerPaymentProfileStatusAffichage,
  playerPaymentProfileStatus,
} from '@/helpers/ProfileHelpers';
import {
  ProductSourceInfo,
  getProductSourceFromQueryParams,
  isProductSource2eChance,
} from '@/helpers/ProductSourceHelpers';
import { erreurDefaut } from '@/helpers/RouteHelpers';

import { getCurrentDate } from '@/js/validators/utils';

const install = function (Vue, options) {
  Vue.mixin({
    methods: {
      // On traite les propriétés définies dans ce fichier:
      // \magnolia\light-modules\jel-lm\dialogs\includes\tabs\tabAffichage.yaml
      // content: contenu du composant
      // json: classes CSS additionnelles
      jel_getClassObject(content, json = {}) {
        if (!content) return;

        let jsonBaseComponent = {};

        // Les lignes suivantes doivent être exécutées en premier,
        // avant les règles d'affichage
        if (content.classeCSSMobile && this.$isMobile()) {
          jsonBaseComponent = getClassesCss(content.classeCSSMobile);
        } else if (content.classeCSS) {
          jsonBaseComponent = getClassesCss(content.classeCSS);
        }
        if (content.espacement) {
          Object.assign(jsonBaseComponent, getClassesEspacement(content.espacement));
        }
        if (content.alignement) {
          jsonBaseComponent[`text-${content.alignement}`] = true;
        }
        if (content.justifie) {
          jsonBaseComponent[`justify-content-${content.justifie}`] = true;
        }
        if (content.restreindreLargeur === 'true') {
          jsonBaseComponent['restreindre-largeur'] = true;
        }

        if (!inEditor) {
          let bCache = false;

          // On cache le composant selon certaines conditons, sinon par défaut visible
          if (content.affichage) {
            if (inAppMobile()) {
              if (content.affichage !== 'appMobile') {
                // d-xs-none nécessaire au lieu de d-none (!important)
                bCache = true;
              }
            } else if (
              content.affichage == 'appMobile' ||
              (content.affichage == 'desktop' && this.$isMobile()) ||
              (content.affichage == 'mobile' && !this.$isMobile()) ||
              (content.affichage == 'telephonePetit' && this.$mq !== 'xs') ||
              (content.affichage == 'telephone' &&
                (this.$mq == 'md' || this.$mq == 'lg' || this.$mq == 'xl' || this.$mq == 'xxl')) ||
              (content.affichage == 'tablette' && this.$mq !== 'md') ||
              (content.affichage == 'desktop&Tablette&GrandTelephone' && this.$mq == 'xs') ||
              (content.affichage == 'petitDesktop&Tablette&GrandTelephone' &&
                (this.$mq == 'xs' || this.$mq == 'xl' || this.$mq == 'xxl')) ||
              (content.affichage == 'desktop&Tablette' && (this.$mq == 'xs' || this.$mq == 'sm')) ||
              (content.affichage == 'largeurDesktop' &&
                (this.$mq == 'xs' || this.$mq == 'sm' || this.$mq == 'md')) ||
              (content.affichage == 'largeurGrandDesktop' &&
                (this.$mq == 'xs' || this.$mq == 'sm' || this.$mq == 'md' || this.$mq == 'lg'))
            ) {
              // d-xs-none nécessaire au lieu de d-none (!important)
              bCache = true;
            }
            // Cache le composant selon les codes promo
            if (content.affichage == 'sansCodePromo') {
              bCache = hasCodePromo() || isProductSource2eChance();
            } else if (content.affichage == 'avecCodePromo') {
              bCache = !hasCodePromo();
            } else if (content.affichage == 'avecCodePromoOuProductSource2emeChance') {
              bCache = !isProductSource2eChance() && !hasCodePromo();
            }
          }

          // Cache le composant selon les dates d'affichage
          if (!bCache) {
            bCache = isCacheDate(content.dateDebut, content.dateFin);
          }

          // https://lotoquebec.atlassian.net/browse/NAVCAT-547
          if (!bCache && content.affichageConnexion) {
            if (content.affichageConnexion == 'connecte' && !session.sessionEstOuverte()) {
              bCache = true;
            } else if (content.affichageConnexion == 'deconnecte' && session.sessionEstOuverte()) {
              bCache = true;
            }
          }

          if (!bCache && content.affichageReprise) {
            const state = store.state.routes;
            const previousRoute =
              state.routerHistory.length > 1
                ? state.routerHistory[state.routerHistory.length - 2]
                : null;

            if (
              content.affichageReprise == 'reprise' && // Reprise parcours d'inscription
              previousRoute &&
              !/\/account\/identity-retry|\/compte\/identite-reprise/i.test(previousRoute.path)
            ) {
              bCache = true;
            } else if (
              content.affichageReprise == 'parcours' && // Parcours d'inscription normal
              previousRoute &&
              /\/account\/identity-retry|\/compte\/identite-reprise/i.test(previousRoute.path)
            ) {
              bCache = true;
            }
          }

          if (
            !bCache &&
            content.infolettre &&
            // eslint-disable-next-line no-undef
            content.infolettre !== ejApi.lireInfoSession('contact_ok')
          ) {
            bCache = true;
          }

          // Cache le composant selon le cookie "visite"
          if (!bCache) {
            bCache = isCacheCookieVisite(content.cookieVisite);
          }
          // Cache le composant selon le cookie "requis"
          if (!bCache) {
            bCache = isCacheCookieRequis(content.nomCookieRequis);
          }

          const { affichageStatusFlag } = this.content;
          if (!bCache && affichageStatusFlag && affichageStatusFlag.length > 0) {
            const { profileDetails } = this.$store.state.profile;
            if (profileDetails) {
              // Intersection entre playerPaymentProfileStatusAffichage et profileDetails
              const profileDetailsStatusFiltre =
                this.$store.state.profile.profileDetails.status.filter((value) =>
                  playerPaymentProfileStatusAffichage.includes(value)
                );

              if (affichageStatusFlag[0] == 'aucun') {
                bCache = profileDetailsStatusFiltre.length > 0;
              } else if (this.content.affichageStatusFlagCondition == 'ou') {
                bCache = !affichageStatusFlag.some(
                  (elem) => profileDetailsStatusFiltre.indexOf(elem) > -1
                );
              } else if (this.content.affichageStatusFlagCondition == 'et') {
                bCache = !affichageStatusFlag.every(
                  (elem) => profileDetailsStatusFiltre.indexOf(elem) > -1
                );
              } else {
                // "etExclusif" par défaut
                bCache =
                  affichageStatusFlag.length !== profileDetails.status.length ||
                  !affichageStatusFlag.every((elem) => profileDetails.status.indexOf(elem) > -1);
              }
              if (
                // TODO: Enlever ce bloc après refonte avec nouvelles pages échec distinctes
                // (avec ou sans documents envoyés) au prochain déploiement PO
                bCache == false &&
                // Pas parcours d'inscription avec documents envoyés
                // Permet affichage conditionnel en fonction du status flag
                content.affichageReprise !== 'documents' &&
                // StatusFlag UPLOAD_ID
                this.$store.state.profile.profileDetails.status.includes(
                  playerPaymentProfileStatus.UPLOAD_ID
                )
              ) {
                bCache = true;
              } else if (
                // TODO: Enlever ce bloc après refonte avec nouvelles pages échec distinctes
                // (avec ou sans documents envoyés) au prochain déploiement PO

                // Parcours d'inscription avec documents envoyés
                // Permet affichage conditionnel en fonction du status flag
                content.affichageReprise == 'documents' &&
                // StatusFlag UPLOAD_ID
                this.$store.state.profile.profileDetails.status.includes(
                  playerPaymentProfileStatus.UPLOAD_ID
                )
              ) {
                bCache = false;
              }
            } else {
              bCache = true;
            }
          }

          const { affichageProductSource } = this.content;
          if (!bCache && affichageProductSource && affichageProductSource.length > 0) {
            if (this.$route.query[ProductSourceInfo.PRODUCT_SOURCE]) {
              bCache = !affichageProductSource.find(
                (productSourceMagnolia) =>
                  productSourceMagnolia == this.$route.query[ProductSourceInfo.PRODUCT_SOURCE]
              );
            } else {
              bCache = !affichageProductSource.find(
                (productSourceMagnolia) => productSourceMagnolia == 'aucun'
              );
            }
          }
          if (!bCache) {
            bCache = this.content.langueAffichage && this.content.langueAffichage !== i18n.locale;
          }

          if (bCache) {
            // Retirer d-flex car il a préséance sur d-none.
            delete jsonBaseComponent['d-flex'];
            jsonBaseComponent['d-none'] = true;
          }
        }

        // eslint-disable-next-line consistent-return
        return Object.assign(json, jsonBaseComponent);
      },

      /*
       * Méthode pour vérifier si un composant est affichable
       * @param {*} content
       */
      jel_isComponentVisible(content) {
        // Le dernier paramètre isSetCookieVisite=false pour ne pas mettre à jour le cookie de visite
        const classObject = this.jel_getClassObject(content, {});
        return !classObject['d-none'];
      },

      /*
       * Écrire le cookie de première visite si nécessaire
       * @param {*} content
       */
      jel_setCookieAffichage(content, isPremiereVisite = true) {
        const { cookieVisite } = content;

        if (!cookieVisite) return;
        if (isPremiereVisite && cookieVisite.field !== 'visite') return;
        if (!isPremiereVisite && cookieVisite.field !== 'fermeture') return;
        if (Cookies.get(cookieVisite.nomCookieVisite) !== undefined) return;

        // eslint-disable-next-line no-undef
        ejApi.ecrireCookie(
          cookieVisite.nomCookieVisite,
          true,
          cookieVisite.dureeCookieVisite || 10 // 10 jours par défaut
        );
      },
      /*
       * Écrire le cookie de visite par fermeture si nécessaire
       * @param {*} content
       */
      jel_setCookieAffichageFermeture(content) {
        this.jel_setCookieAffichage(content, false);
      },

      /**
       * Retourne un binding lien router ou href selon lien INTERNE ou EXTERNE seulement.
       *
       * Ajouter à un component en utilisant v-bind=getLienBinding(lien)
       *
       * @param {Object} lien Objet de type lien contenant un lien EXTERNE ou INTERNE seulement
       *
       * @return {Object} Retourne un objet contenant le binding a associer à un élément html.
       */
      jel_getLienBinding(lien) {
        let lienNettoyer = this.jel_nettoyerLien(lien);
        /**
         * Actuellement dans Magnolia 6 toutes les images ont un lien de type 'lienInterne' défini sans URL
         * Pour éviter d'avoir les images grisées à cause du lien disabled,
         * on ne veut pas avoir les 'lienInterne' désactivés à court/moyen terme.
         * Il faudra prévoir de remplacer tous les liens sur les images par le type de lien 'aucunlien',
         * mais ça nécessite de redéployer toutes les pages qui utilisent des images.
         * Ça pourrait se faire dans un livraison de maintenance.
         */
        if (lienNettoyer == '' && (!lien?.field || !lien.field.startsWith('lienInterne'))) {
          return {
            disabled: true,
          };
        }

        // On test si la connexion Auth0 est active
        if (
          typeof ejApi !== 'undefined' &&
          process.env.VUE_APP_CIAM_ENABLED === 'true' &&
          ['/connexion', '/log-in'].includes(lienNettoyer)
        ) {
          const params = new URLSearchParams(window.location.search);
          const productSource = params.get([ProductSourceInfo.PRODUCT_SOURCE]);
          const lienInterneNettoye = this.jel_nettoyerLienInterne(
            PageMapping.IDENTITE_REPRISE.siteUrl
          );
          const urlReprise = store.getters['routes/getUrlFromWebsitePath'](lienInterneNettoye);
          let returnUrl = `${process.env.VUE_APP_PROXY_URL_POD}/${this.$i18n.locale}${urlReprise}`;
          if (productSource) {
            returnUrl = `${returnUrl}?${params}`;
          }
          return {
            href: `javascript:lancerConnexionAuth0('${this.$i18n.locale}', '${returnUrl}')`,
          };
        }

        // Tenter de passer le product_source s'il y a lieu
        if (lien.isPasserProductSource && lien.isPasserProductSource == 'true') {
          const productSource = getProductSourceFromQueryParams();
          if (productSource) {
            lienNettoyer += `${
              (lienNettoyer.indexOf('?') == -1 ? '?' : '&') + ProductSourceInfo.PRODUCT_SOURCE
            }=${productSource}`;
          }
        }
        if (lien.urlParams) {
          lienNettoyer += (lienNettoyer.indexOf('?') == -1 ? '?' : '&') + lien.urlParams;
        }

        // lienInterne
        if (lien.field.startsWith('lienInterne')) {
          let query = {};

          // On s'attend à avoir une liste de paramètres sous forme "par1=val1&par2=val2"
          // Si ce n'est pas le cas, on ignore complètement la saisie
          try {
            query = JSON.parse(
              `{"${lien.urlParams.replace(/&/g, '","').replace(/=/g, '":"')}"}`,
              function (key, value) {
                return key === '' ? value : decodeURIComponent(value);
              }
            );
            // eslint-disable-next-line no-empty
          } catch (error) {}

          return {
            // Utilise le router si nous avons un lien interne. Assume que lien interne commence par /
            to: { path: lienNettoyer, query },
          };
        }

        // lienExterne
        const lienExterne = {
          href: lienNettoyer,
        };
        if (lien.isTargetBlank && lien.isTargetBlank == 'true') {
          lienExterne.target = '_blank';
        }
        return lienExterne;
      },

      // Retourne le path de l'image
      // IMPORTANT: S'assurer que la ressource est référencée dans \magnolia\light-modules\jel-lm\restEndpoints
      jel_getFichierSrc(fichier) {
        return getUrlContext(process.env.VUE_APP_BASE_DAM + fichier['@path']);
      },
      jel_getImageSrcFocalPoint(image, formatRatio, largeur = window.screen.width) {
        if (!image) {
          return '';
        }

        if (!image.metadata) {
          // On retourne l'image par défaut
          image = this.$store.state.produitCasino.imageDefaut;
        }

        const largeursPermises = [375, 768, 1024, 1600, 1920];
        const largeurPermise =
          largeursPermises.find((element) => element >= largeur) ??
          largeursPermises[largeursPermises.length - 1];

        let cheminImage;
        if (image.metadata.format && image.metadata.format.startsWith('image/svg')) {
          cheminImage = `${process.env.VUE_APP_BASE_DAM}/jel/${image['@id']}/${image['@name']}.svg`;
        } else if (isWebpSupported()) {
          cheminImage = `/.imaging/focalpoint/${formatRatio}/${largeurPermise}x/dam/${image['@id']}/${image['@name']}.webp`;
        } else {
          cheminImage = `/.imaging/focalpointpng/${formatRatio}/${largeurPermise}x/dam/${image['@id']}/${image['@name']}.png`;
        }

        return getUrlContext(cheminImage);
      },
      jel_getMagnoliaPathName() {
        const nodeName = process.env.VUE_APP_SITE_BASENAME;
        return window.location.pathname.replace(new RegExp(`(.*${nodeName}|.html)`, 'g'), '');
      },

      // Chercher dans le texte pour des tokens et les remplacer
      jel_replaceTokens(texte) {
        const tokens = extractTokens(texte);

        if (tokens) {
          return replaceTokensWithStoreVal(replaceDateToken(texte, tokens), tokens);
        }

        return texte;
      },

      // Nettoyer un lien
      // Le champ doit être référencé dans \magnolia\light-modules\jel-lm\restEndpoints\delivery\pages_v1.yaml
      jel_nettoyerLien(lien) {
        if (!lien) {
          return '';
        }

        if (lien.field == 'lienInterne' && lien.lienInterne) {
          if (lien.isDejaNettoye) {
            return lien.lienInterne;
          }
          const lienInterneNettoye = this.jel_nettoyerLienInterne(lien.lienInterne);
          return store.getters['routes/getUrlFromWebsitePath'](lienInterneNettoye);
        }

        if (lien.field == 'lienExterne' && lien.lienExterne) {
          return nettoyerLienExterne(lien.lienExterne);
        }

        if (lien.field == 'lienInterneCasinoProduit' && lien.idProduit) {
          const produit = this.$store.getters['produitCasino/getByUuid'](lien.idProduit);
          let produitNameI18n;
          let categorie;
          if (produit) {
            produitNameI18n = this.$i18n.locale == 'en' ? produit.nameEn : produit.name;

            categorie = this.$i18n.t(
              `casino.categorie.${produit.typeJeu ? produit.typeJeu : produit.categorie}.slug`
            );
            if (produitNameI18n) {
              return `${store.getters['routes/getUrlFromWebsitePath'](
                process.env.VUE_APP_SITE_BASENAME + PageMappingCasino.CASINO_PRODUIT.siteUrl
              )}/${`${categorie}/`}${produitNameI18n}`;
            }
          }
          return '';
        }

        if (lien.field == 'lienInterneCasinoCollection' && lien.idProduitCollection) {
          const nameI18n = store.getters['produitCollection/getNameI18nByUuid'](
            lien.idProduitCollection
          );
          if (nameI18n) {
            return `${store.getters['routes/getUrlFromWebsitePath'](
              process.env.VUE_APP_SITE_BASENAME + PageMappingCasino.CASINO_COLLECTION.siteUrl
            )}/${nameI18n}`;
          }
        }

        if (lien.field == 'escamotable' && lien.lienInterne && lien.idEscamotable) {
          if (lien.isDejaNettoye) {
            return `${lien.lienInterne}#${lien.idEscamotable}`;
          }
          const lienInterneNettoye = this.jel_nettoyerLienInterne(lien.lienInterne);
          return `${store.getters['routes/getUrlFromWebsitePath'](lienInterneNettoye)}#${
            lien.idEscamotable
          }`;
        }

        return '';
      },

      /**
       * Retourne le lien externe en fonction de l'env. courant
       *
       * @param {string} lienExterne lien sous la forme de //www.espacejeux.com ou https://aaa.bbb.com
       *
       * @return {string} Retourne l'url
       */
      jel_nettoyerLienExterne(lienExterne) {
        return nettoyerLienExterne(lienExterne);
      },

      /**
       * Retourne le lien interne nettoyé
       *
       * La valeur peut être utilisée selon le mapping anglais/francais
       *
       * @param {string} lienInterne lien sous la forme de baseUrl/magnolia/cheminPage.html
       *
       * @return {string} Retourne cheminPage de l'url
       */
      jel_nettoyerLienInterne(lienInterne) {
        // Retirer le "host" s'il y a lieu
        try {
          const url = new URL(lienInterne);
          lienInterne = url.pathname;
        } catch (error) {
          // Aucun host, on prend le lien tel quel
        }
        if (lienInterne) {
          // fallback: https://jira.magnolia-cms.com/browse/SUPPORT-13170
          const regex = new RegExp(
            '\\b\\.html|/magnoliaAuthor|/magnoliaPublic|/fallback|/fr|/en\\b',
            'gi'
          );
          lienInterne = lienInterne.replace(regex, '');
          if (!lienInterne.startsWith(process.env.VUE_APP_SITE_BASENAME)) {
            lienInterne = process.env.VUE_APP_SITE_BASENAME + lienInterne;
          }
        }
        return lienInterne;
      },

      jel_libelleLienGoogleAnalytics(lien) {
        let libelle = null;
        const lienNettoye = this.jel_nettoyerLien(lien);
        if (lienNettoye) {
          if (lien.field.startsWith('lienInterne')) {
            if (lien.field == 'lienInterneCasinoCollection') {
              libelle = 'Page collection Casino ';
            } else if (lien.field == 'lienInterneCasinoProduit') {
              libelle = 'Page produit Casino ';
            } else {
              libelle = 'Page interne ';
            }
            libelle += `/${this.$i18n.locale}${lienNettoye}`;
          } else if (lien.field.startsWith('lienExterne')) {
            libelle = `Page externe ${lienNettoye}`;
          }
        }
        if (lien.field.startsWith('modale')) {
          libelle = `Lien vers ${window.location.pathname}#${lien.field}`;
        }
        return libelle;
      },

      jel_isAppleDevice() {
        return /Macintosh|MacIntel|MacPCC|Mac68k|iPhone|iPad|iPod/i.test(navigator.userAgent);
      },

      jel_isAppleMobile() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
      },

      jel_isIPhoneOrIPod() {
        return /iPhone|iPod/i.test(navigator.userAgent);
      },

      jel_isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      },

      jel_isAppleWebView() {
        const ua = navigator.userAgent;
        // Vérifie si c'est une WebView iOS (absence de Safari/ mais présence d'AppleWebKit et Mobile)
        const isIOS = /(iPhone|iPad)/.test(ua);
        const isWebKit = /AppleWebKit/.test(ua) && !/Safari/.test(ua);

        return isIOS && isWebKit;
      },

      jel_applePayActif() {
        return this.jel_isSafari() || this.jel_isAppleWebView();
      },

      jel_googlePayActif() {
        // Ancienne logique de vérification de compatibilité navigateur
        // if (browser().match(/chrome/gi) && browserVersion() >= 59) {
        //   return true;
        // }
        // if (browser().match(/edge/gi) && browserVersion() >= 79) {
        //   return true;
        // }
        // if (browser().match(/firefox/gi) && browserVersion() >= 59) {
        //   return true;
        // }
        // if (browser().match(/opera/gi) && browserVersion() >= 50) {
        //   return true;
        // }
        // if (browser().match(/safari/gi) && browserVersion() >= 1) {
        //   return true;
        // }
        // return false;

        // Cacher Google Pay pour les apps iOS et l'app MOJ+ (temporaire)
        return !inIOSApp() && !inMojPlusApp();
      },

      jel_argentWebActif() {
        // TODO coder conditions pour argent Web actif
        return true;
      },

      jel_paiementFacturesActif() {
        // TODO coder conditions pour argent Web actif
        return true;
      },

      // forcer le click d'un hyperlien référencé
      jel_forcerClickHyperlien(referenceRedirection) {
        // Permettre l'édition dans Mangolia
        if (!inEditor) {
          const element = this.$refs[referenceRedirection].$el;
          if (element && !window.location.href.includes(element.getAttribute('href'))) {
            element.click();
          }
        }
      },
      jel_getClasseLargeurCarte(width, widthPetit = 256, widthBase = 315) {
        if (widthBase < widthPetit) {
          widthPetit = widthBase;
        }
        if (width < widthPetit) {
          return 'minimum';
        }
        if (width >= widthBase) {
          return 'base';
        }
        return 'petit';
      },
      jel_isCarteLarge(content) {
        return !content.isListeHorizontale && this.jel_isEcranDesktop(this.$mq);
      },
      jel_isEcranDesktop(mq) {
        return mq == 'lg' || mq == 'xl' || mq == 'xxl';
      },
      jel_isEcranTablette(mq) {
        return mq == 'md' || mq == 'sm';
      },
      jel_isEcranMobile(mq) {
        return mq == 'xs';
      },
      /**
       * Méthode pour traiter le retour vers url précédente
       */
      jel_traiterRetour() {
        if (this.jel_historiqueRouteurPresent()) {
          this.$router.go(-1);
        } else {
          const path = window.location.pathname;
          if (
            document.referrer &&
            !/\/erreur|\/error|\/connexion|\/log-in/i.test(document.referrer) &&
            !path.includes('casino')
          ) {
            if (document.referrer.includes('paysafe')) {
              this.$router.go(-1);
            } else {
              window.location.href = document.referrer;
            }
          } else if (path.includes('casino')) {
            if (path.includes('/casino/p/')) {
              const index = path.endsWith('/')
                ? path.slice(0, path.length - 1).lastIndexOf('/')
                : path.lastIndexOf('/');
              window.location.href = path.slice(0, index).replace('/p', '');
            } else {
              const uriReturn = this.$store.getters['routes/getUrlFromWebsitePath'](
                PageMappingCasino.CASINO_ACCUEIL.siteUrl
              );
              this.$router.push(uriReturn).catch(() => {
                console.log('Route inexistante: ', uriReturn);
              });
            }
          } else {
            window.location.href = nettoyerLienExterne(erreurDefaut.url);
          }
        }
      },

      /*
       * On regarde s'il y a un historique dans le store du router,
       * si oui, on redirige l'utilisateur vers la page précédente,
       * sinon on redirige vers la page d'accueil (Portail Loto-Québec ou Casino)
       */
      jel_historiqueRouteurPresent() {
        const state = store.state.routes;
        return (
          state.routerHistory.length > 1 && state.routerHistory[state.routerHistory.length - 1]
        );
      },

      // Obtenir le nom de la route courante à titre analytique
      jel_getNomRouteCourante() {
        const currentRoutePath = router.currentRoute.path;
        const { routes } = store.state.routes;
        const currentRoute = routes.find((route) => route['@path'] == currentRoutePath);
        return currentRoute?.websitePath;
      },

      jel_gaGetEmplacement() {
        let emplacement = '';
        const currentPath = window.location.pathname;
        if (/fr\/casino\/accueil/i.test(currentPath) || /en\/casino\/home/i.test(currentPath)) {
          emplacement = 'Accueil Casino';
        } else if (
          /fr\/casino\/machines-a-sous\/accueil/i.test(currentPath) ||
          /en\/casino\/slot-machines\/home/i.test(currentPath)
        ) {
          emplacement = 'Accueil MAS';
        } else if (
          /fr\/casino\/jeux\/accueil/i.test(currentPath) ||
          /en\/casino\/games\/home/i.test(currentPath)
        ) {
          emplacement = 'Accueil Jeux';
        } else if (
          /fr\/casino\/halloween/i.test(currentPath) ||
          /en\/casino\/halloween/i.test(currentPath)
        ) {
          emplacement = 'Jeux Halloween';
        } else if (
          /fr\/casino\/p\/machines-a-sous/i.test(currentPath) ||
          /en\/casino\/p\/slot-machines/i.test(currentPath)
        ) {
          emplacement = 'Fiche de jeu MAS';
        } else if (
          /fr\/casino\/p\/machines-a-sous-en-direct/i.test(currentPath) ||
          /en\/casino\/p\/live-slot-machines/i.test(currentPath)
        ) {
          emplacement = 'Fiche de jeu MAS en direct';
        } else if (
          /fr\/casino\/p\/jeux-de-table/i.test(currentPath) ||
          /en\/casino\/p\/table-games/i.test(currentPath)
        ) {
          emplacement = 'Fiche de jeu JDT';
        } else if (
          /fr\/casino\/p\/keno/i.test(currentPath) ||
          /en\/casino\/p\/keno/i.test(currentPath)
        ) {
          emplacement = 'Fiche de jeu KENO';
        } else if (
          /fr\/casino\/casino-en-direct/i.test(currentPath) ||
          /en\/casino\/live-casino/i.test(currentPath)
        ) {
          emplacement = 'Casino en direct';
        } else if (
          /fr\/casino\/c\/les-classiques/i.test(currentPath) ||
          /en\/casino\/c\/classics/i.test(currentPath)
        ) {
          emplacement = 'Collection Les classiques';
        } else if (
          /fr\/casino\/c\/progressif/i.test(currentPath) ||
          /en\/casino\/c\/jackpot/i.test(currentPath)
        ) {
          emplacement = 'Collection Lots progressifs';
        } else if (
          /fr\/casino\/c\/casino-en-direct/i.test(currentPath) ||
          /en\/casino\/c\/live-casino/i.test(currentPath)
        ) {
          emplacement = 'Collection CED';
        } else if (
          /fr\/casino\/c\/jeux-/i.test(currentPath) ||
          /en\/casino\/c\/games-/i.test(currentPath)
        ) {
          emplacement = 'Collection JDT';
        } else if (
          /fr\/casino\/c\/keno/i.test(currentPath) ||
          /en\/casino\/c\/keno/i.test(currentPath)
        ) {
          emplacement = 'Collection Keno';
        } else if (
          /fr\/casino\/c\/machines-a-sous/i.test(currentPath) ||
          /en\/casino\/c\/slot-machines/i.test(currentPath)
        ) {
          emplacement = 'Collection MAS';
        } else if (
          /fr\/casino\/c\/sports-virtuels/i.test(currentPath) ||
          /en\/casino\/c\/virtual-sports/i.test(currentPath)
        ) {
          emplacement = 'Collection Sports Virtuels';
        } else if (
          /fr\/casino\/c\/joues-recemment/i.test(currentPath) ||
          /en\/casino\/c\/last-played/i.test(currentPath)
        ) {
          emplacement = 'Collection joués récemment';
        } else if (
          /fr\/casino\/c\/favoris/i.test(currentPath) ||
          /en\/casino\/c\/favorites/i.test(currentPath)
        ) {
          emplacement = 'Collection favoris';
        } else if (
          /fr\/casino\/categories/i.test(currentPath) ||
          /en\/casino\/categories/i.test(currentPath)
        ) {
          emplacement = 'Menu toutes catégories';
        } else if (/fr\/casino\/c/i.test(currentPath) || /en\/casino\/c/i.test(currentPath)) {
          emplacement = 'Collection';
        } else if (/fr\/promotion/i.test(currentPath) || /en\/promotion/i.test(currentPath)) {
          emplacement = 'Marchandisage Casino';
        } else if (
          /fr\/bingo\/accueil/i.test(currentPath) ||
          /en\/bingo\/home/i.test(currentPath)
        ) {
          emplacement = 'Accueil Bingo';
        } else if (
          /fr\/bingo\/offres-speciales/i.test(currentPath) ||
          /en\/bingo\/special-offers/i.test(currentPath)
        ) {
          emplacement = 'Offres spéciales Bingo';
        }
        return emplacement;
      },
      jel_isRecaptchaActive() {
        return (
          !inMgnl &&
          process.env.VUE_APP_IS_MOCK === 'false' &&
          this.content.activerRecaptcha === 'true'
        );
      },
      jel_ouvrirFenetre(url, name, fullScreen, resizable, scrollbars) {
        const params = `fullscreen=${fullScreen},resizable=${resizable},scrollbars=${scrollbars},status=yes`;

        const popup = window.open(url, name, params);
        if (
          popup.outerWidth < window.screen.availWidth ||
          popup.outerHeight < window.screen.availHeight
        ) {
          popup.moveTo(0, 0);
          popup.resizeTo(window.screen.availWidth, window.screen.availHeight);
        }
        popup.focus();
      },
    },
  });
};

// Chercher dans le texte pour des tokens
// et les remplacer par les valeurs du store correspondantes
function replaceTokensWithStoreVal(texte, tokens) {
  tokens.forEach((element) => {
    texte = texte.replace(`{{${element}}}`, getValue(element));
  });

  return texte;
}

/**
 * Supporte le format de token {{date|MOMENT_ACCEPTED_FORMAT}}
 * @param {string} texte Le texte dans lequel pourrait se contenir la date du jour à remplacer
 * @return {string} la texte avec les tokens date remplacer
 * Il serait intéressant de regarder la possibilité d'utliser une config du CKEditor pour remplacer la date coté serveur:
 * https://documentation.magnolia-cms.com/display/DOCS62/Rich+text+field
 */
function replaceDateToken(texte) {
  const tokens = extractTokens(texte);
  const dateToken = 'Date|';
  if (tokens) {
    tokens.forEach((element) => {
      if (element.includes(dateToken)) {
        const dateFormat = element.split(dateToken).pop();
        texte = texte.replace(`{{${element}}}`, getCurrentDate(dateFormat));
      }
    });
  }
  return texte;
}

// Retourne une valeur du store "compte".
// Si non trouvée, on retourne la valeur imbriquée dans le store en utilisant "_.get" de loadash.
// Nomenclature utilisée: obj.obj.propriété (ex: session.sessionDetails.balance)
function getValue(element) {
  if (store.state.compte[element]) {
    return store.state.compte[element];
  }
  const val = _.get(store.state, element);
  return val || '';
}

// Cette méthode privée extrait tous les tokens contenus dans le texte
function extractTokens(texte) {
  const pattern = /{{([\s\S]*?)}}/g; // Éléments délimités par {{ et }}

  let tokens;
  const tokensArr = [];
  // eslint-disable-next-line no-cond-assign
  while ((tokens = pattern.exec(texte)) !== null) {
    tokensArr.push(tokens[1]); // On pousse la valeur sans les {{}}
  }
  return tokensArr;
}

function getClassesCss(contentCss) {
  if (!contentCss) return {};

  return contentCss.split(' ').reduce((acc, ele) => {
    acc[ele] = true;
    return acc;
  }, {});
}

function getClassesEspacement(contentEspacement) {
  let contentCss = '';
  contentEspacement['@nodes'].forEach((espacement) => {
    const espacementCourant = contentEspacement[espacement];
    contentCss += `${espacementCourant.espacement}${espacementCourant.position}${
      espacementCourant.resolution || ''
    }${espacementCourant.niveau.slice(0, -2)} `; // l'outil magnolia ajoute automatiquement une décimale
  });
  return getClassesCss(contentCss);
}

// Inspiration: https://stackoverflow.com/questions/5573096/detecting-webp-support
function isWebpSupported() {
  const elem = document.createElement('canvas');

  if (elem.getContext && elem.getContext('2d')) {
    // was able or not to get WebP representation
    return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
  }

  // very old browser like IE 8, canvas not supported
  return false;
}

function isCacheDate(dateDebut, dateFin) {
  if (!dateDebut && !dateFin) return false;

  const maintenant = moment();
  const debut = dateDebut ? moment(dateDebut).tz('America/Montreal', true) : null;
  const fin = dateFin ? moment(dateFin).tz('America/Montreal', true) : null;

  return (debut && debut.isAfter(maintenant)) || (fin && fin.isBefore(maintenant));
}

// On cache le composant s'il a été vu lors d'une première visite
// Sinon, on enregistre le cookie
function isCacheCookieVisite(cookieVisite) {
  if (!cookieVisite) return false;
  if (!cookieVisite.field) return false;

  // On cache le composant si le cookie existe
  return Cookies.get(cookieVisite.nomCookieVisite) !== undefined;
}
// On cache le composant si le cookie requis n'est pas présent
function isCacheCookieRequis(nomCookieRequis) {
  if (!nomCookieRequis) return false;

  return Cookies.get(nomCookieRequis) === undefined;
}

export default install;
